/**
 * iconMaps.js
 *
 * Centralised icon dictionaries previously duplicated inside
 * PrivateSuitePage.jsx. Pulled out as the first step of a multi-pass
 * decomposition of that 5,000-line file. Pure data — zero behaviour
 * change.
 */
import {
  Dumbbell, Flag, Target, Wind, Swords, Waves, Trophy, Moon,
  Shield, Heart, Leaf,
} from "lucide-react";

export const ACTIVITY_ICONS = {
  gym: Dumbbell,
  golf: Flag,
  tennis: Target,
  running: Wind,
  martial_arts: Swords,
  swimming: Waves,
  general: Trophy,
  sleep: Moon,
  core_confidence: Shield,
};

export const RECOVERY_ICONS = {
  ptsd_support: Shield,
  deep_sleep: Moon,
  nervous_system: Heart,
  trauma_release: Leaf,
};
